export function stations (state) {
  return state?.stations?.data || null
}
